import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const TestimonialSection = () => {
  const [testimonial, setTestimonial] = useState([]);

  const [testimonialtext, setTestimonialText] = useState([]);
  const { pageSlug } = useParams(); // Extract the blog post titleSlug from the URL
  const [page, setPage] = useState([]);

  useEffect(() => {
    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/page/${pageSlug}`)
      .then((res) => res.json())
      .then((info) => setPage(info))
      .catch((error) => console.error("Error fetching banners:", error));
  }, []);

  useEffect(() => {
    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/testimonialtext`)
      .then((res) => res.json())
      .then((info) => setTestimonialText(info));
  }, []);

  useEffect(() => {
    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/testimonials`)
      .then((res) => res.json())
      .then((info) => setTestimonial(info));
  }, []);


  const divStyle = {
    backgroundImage: "url(img/testimonial/test-bg-aliments.png)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundColor: "#fff7f5",
  };

  return (


    <>

      <section className="clients-sec" id="feedback">
        <div className="container">
          {
            testimonialtext.map(b => b.pageSlug === page.pageSlug && <h2 className="section-heading color-black">{b.testimonialHeading}</h2>)}

          <div className="container my-4">
            <div className="row g-4">

              {
                testimonial.map(e => e.pageSlug === page.pageSlug && <div className="col-lg-4 col-sm-12">
                  <div className="card p-3 text-center shadow-sm">
                    <div className="image mb-3">
                      <img
                        src={e.image}
                        alt="testimonial"
                        className="img-fluid rounded-circle"
                        style={{ width: "80px", height: "80px" }}
                      />
                    </div>
                    <p className="text-muted">
                      {e.desc}
                    </p>
                    
                    <h5 className="fw-bold"
                      style={{ color: "#F41A77", fontSize: "1.5rem", letterSpacing: "1px" }}>
                      — {e.personName}
                    </h5>
                    <h5 >{e.personTitle}</h5>

                  </div>
                </div>)}



            </div>
          </div>

        </div>
      </section>

    </>


  );
};

export default TestimonialSection;
